import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './SystemDetails.module.css';
import Header from '../Shared/Header';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ScreenSelector from './ScreenSelector';
import SystemScreen from './SystemScreen';
import ModulesScreen from './ModulesScreen';
import { getLastEntries } from '../../api/metricsService';
import { getSystemDetails } from '../../api/bessService';
import { useTokenCheck } from '../../hooks/useTokenCheck';

const SystemDetails = () => {
  useTokenCheck();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { systemId } = useParams();
  const system = useSelector((state) => state.bessReducer.details[systemId]);
  const [screenToShow, setScreenToShow] = useState('system');
  const [refreshData, setRefreshData] = useState(true);
  useEffect(() => {
    if (refreshData) {
      dispatch(getLastEntries(systemId));
      dispatch(getSystemDetails(systemId));
      setRefreshData(false);
    }
  }, [systemId, refreshData]);

  return (
    <div className={styles.container}>
      <Header
        title={system.name}
        refreshButton
        onRefreshClicked={() => setRefreshData(true)}
      />
      <div className={styles.screenSelectorsContainer}>
        <ScreenSelector
          text={t('system')}
          onSelected={() => setScreenToShow('system')}
          selected={screenToShow === 'system'}
        />
        <ScreenSelector
          text={t('modules')}
          onSelected={() => setScreenToShow('modules')}
          selected={screenToShow === 'modules'}
        />
      </div>
      <div className={styles.content}>
        {screenToShow === 'system' && <SystemScreen systemId={systemId} />}
        {screenToShow === 'modules' && <ModulesScreen systemId={systemId} />}
      </div>
    </div>
  );
};

export default SystemDetails;
